import { render, staticRenderFns } from "./FreightExchangePanel.vue?vue&type=template&id=135b6638&scoped=true"
import script from "./FreightExchangePanel.vue?vue&type=script&lang=js"
export * from "./FreightExchangePanel.vue?vue&type=script&lang=js"
import style0 from "./FreightExchangePanel.vue?vue&type=style&index=0&id=135b6638&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135b6638",
  null
  
)

export default component.exports